import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputNotANumberErrorMessage = (
  <Trans>
    Ce champ doit contenir un chiffre
  </Trans>
);
